import { render, staticRenderFns } from "./StartupsGrid.vue?vue&type=template&id=2d01f375&scoped=true&"
import script from "./StartupsGrid.vue?vue&type=script&setup=true&lang=js&"
export * from "./StartupsGrid.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d01f375",
  null
  
)

export default component.exports